// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rtl {
  text-align: right;
  direction: rtl;
}
/* 
.MuiDialog-paper[dir="rtl"] {
  text-align: right;
}

.MuiMenuItem-root[dir="rtl"] {
   text-align: right;
} */
body {
  padding-top: 0rem;
  font-family: "Inter" !important;

  /* font-family: "Roboto", serif; */
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: #003462 !important;
}
.mui-1jrzfe4-MuiInputBase-root-MuiOutlinedInput-root {
  font-weight: 600;
  font-size: 1.5rem;
}

table,
th,
td {
  text-align: center !important;
  min-width: fit-content;
  font-family: "Inter" !important;
}
/* th span svg {
  display: none !important;
} */
.bg-custom {
  background-color: #003462 !important;
}
.text-main {
  color: #003462 !important;
}
.stepper .active {
  background-color: #003462 !important;
}
.stepper .completed {
  background-color: rgba(0, 52, 98, 0.9) !important;
}
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  border-radius: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 5px;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.accordion-button:not(.collapsed) {
  background-color: transparent !important;
}

.status {
  /* width: 12px; */
  /* height: 12px; */
  padding: 3px;
  border-radius: 5px ;
  color: white;
  font-size:9px;
  display: inline-block;
}
.icon{
  width: 30px;
  height: 30px;
  background-color: rgb(0, 155, 255);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  /* color: rgb(0, 194, 129); */
  
}
.nav-tabs .nav-link{
  color: #003462;
}

.gantt_task_line.completed {
  background-color: #4caf50 !important; /* green */
  border-color: #388e3c !important;
}
.font-small{
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;;;;;;;GAOG;AACH;EACE,iBAAiB;EACjB,+BAA+B;;EAE/B,kCAAkC;AACpC;AACA;;;;;;EAME,yBAAyB;AAC3B;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;EAGE,6BAA6B;EAC7B,sBAAsB;EACtB,+BAA+B;AACjC;AACA;;GAEG;AACH;EACE,oCAAoC;AACtC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,iDAAiD;AACnD;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA,UAAU;AACV;EACE,mBAAmB;AACrB;AACA,WAAW;AACX;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kCAAkC;EAClC,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,6BAA6B;;AAE/B;AACA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC,EAAE,UAAU;EAChD,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&display=swap\");\n\n.rtl {\n  text-align: right;\n  direction: rtl;\n}\n/* \n.MuiDialog-paper[dir=\"rtl\"] {\n  text-align: right;\n}\n\n.MuiMenuItem-root[dir=\"rtl\"] {\n   text-align: right;\n} */\nbody {\n  padding-top: 0rem;\n  font-family: \"Inter\" !important;\n\n  /* font-family: \"Roboto\", serif; */\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  color: #003462 !important;\n}\n.mui-1jrzfe4-MuiInputBase-root-MuiOutlinedInput-root {\n  font-weight: 600;\n  font-size: 1.5rem;\n}\n\ntable,\nth,\ntd {\n  text-align: center !important;\n  min-width: fit-content;\n  font-family: \"Inter\" !important;\n}\n/* th span svg {\n  display: none !important;\n} */\n.bg-custom {\n  background-color: #003462 !important;\n}\n.text-main {\n  color: #003462 !important;\n}\n.stepper .active {\n  background-color: #003462 !important;\n}\n.stepper .completed {\n  background-color: rgba(0, 52, 98, 0.9) !important;\n}\n::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  border-radius: 5px;\n}\n/* Track */\n::-webkit-scrollbar-track {\n  background: #f1f1f1;\n}\n/* Handle */\n::-webkit-scrollbar-thumb {\n  background: #888;\n  border-radius: 5px;\n}\n/* Handle on hover */\n::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.accordion-button:not(.collapsed) {\n  background-color: transparent !important;\n}\n\n.status {\n  /* width: 12px; */\n  /* height: 12px; */\n  padding: 3px;\n  border-radius: 5px ;\n  color: white;\n  font-size:9px;\n  display: inline-block;\n}\n.icon{\n  width: 30px;\n  height: 30px;\n  background-color: rgb(0, 155, 255);\n  color: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  /* color: rgb(0, 194, 129); */\n  \n}\n.nav-tabs .nav-link{\n  color: #003462;\n}\n\n.gantt_task_line.completed {\n  background-color: #4caf50 !important; /* green */\n  border-color: #388e3c !important;\n}\n.font-small{\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
